export default {
    title: 'Trend radar',
    created: 'Created on {date}'
}
